<template>
  <!-- act-list .al -->
  <div class="al">
    <!-- <filterCommon4 @select="select"></filterCommon4> -->
    <actItem :topic="topic" :nameEn="nameEn" :typeId="typeId" ref="filters"></actItem>
  </div>
</template>

<script>
import filterCommon4 from "@components/En/filter-common3/filter-common4.vue";
import actItem from "./components/act-item.vue";
export default {
  name: "act-list",
  data() {
    return {
    nameEn:-1,
    typeId:'',
      topic: -1, // -4：免费报名，-3：新发布，-2：热搜，-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"
    };
  },
  components: { filterCommon4, actItem },
  computed: {},

  methods: {

    select(type){
        this.nameEn=type.name
        this.typeId=type.id
    },
     childMethod(id,categoryName){
         this.nameEn=categoryName
        this.typeId=id
    },

     childSearch(id,categoryName){
         this.nameEn=categoryName
        this.typeId=id
        this.$refs.filters.getActList()
    },

  }
};
</script>

<style scoped lang="scss">
.al {
  
}
</style>
